import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";

const NotFound = lazy(() => import("@/pages/NotFound"));
const About = lazy(() => import("@/pages/about/page"));
const Services = lazy(() => import("@/pages/services/page"));
const References = lazy(() => import("@/pages/references/page"));
const Faq = lazy(() => import("@/pages/faq/page"));
const Contact = lazy(() => import("@/pages/contact/page"));
const KasetliTente = lazy(() => import("@/pages/services/kasetli-tente/page"));
const KorukluTente = lazy(() => import("@/pages/services/koruklu-tente/page"));
const MafsalliTente = lazy(() => import("@/pages/services/mafsalli-tente/page"));
const TModelTente = lazy(() => import("@/pages/services/t-model-tente/page"));
const WinTente = lazy(() => import("@/pages/services/win-tente/page"));
const BioklimatikPergola = lazy(() => import("@/pages/services/bioklimatik-pergola/page"));
const OtomatikPergola = lazy(() => import("@/pages/services/otomatik-pergola/page"));
const RollingroofPergola = lazy(() => import("@/pages/services/rollingroof-pergola/page"));
const SeffafBranda = lazy(() => import("@/pages/services/seffaf-branda/page"));
const SeffafStorBranda = lazy(() => import("@/pages/services/seffaf-stor-branda/page"));
const ZipPerde = lazy(() => import("@/pages/services/zip-perde/page"));
const Kvkk = lazy(() => import("@/pages/kvkk/page"));
const CerezPolitikasi = lazy(() => import("@/pages/cerez-politikasi/page"));

const wrap = (el: React.ReactNode) => (
  <Suspense fallback={null}>{el}</Suspense>
);

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/hakkimizda", element: wrap(<About />) },
  { path: "/hizmetler", element: wrap(<Services />) },
  { path: "/referanslar", element: wrap(<References />) },
  { path: "/sss", element: wrap(<Faq />) },
  { path: "/iletisim", element: wrap(<Contact />) },
  { path: "/hizmetler/kasetli-tente", element: wrap(<KasetliTente />) },
  { path: "/hizmetler/koruklu-tente", element: wrap(<KorukluTente />) },
  { path: "/hizmetler/mafsalli-tente", element: wrap(<MafsalliTente />) },
  { path: "/hizmetler/t-model-tente", element: wrap(<TModelTente />) },
  { path: "/hizmetler/win-tente", element: wrap(<WinTente />) },
  { path: "/hizmetler/bioklimatik-pergola", element: wrap(<BioklimatikPergola />) },
  { path: "/hizmetler/otomatik-pergola", element: wrap(<OtomatikPergola />) },
  { path: "/hizmetler/rollingroof-pergola", element: wrap(<RollingroofPergola />) },
  { path: "/hizmetler/seffaf-branda", element: wrap(<SeffafBranda />) },
  { path: "/hizmetler/seffaf-stor-branda", element: wrap(<SeffafStorBranda />) },
  { path: "/hizmetler/zip-perde", element: wrap(<ZipPerde />) },
  { path: "/kvkk", element: wrap(<Kvkk />) },
  { path: "/cerez-politikasi", element: wrap(<CerezPolitikasi />) },
  { path: "*", element: wrap(<NotFound />) },
];

export default routes;
